<template lang="pug">
  .search-users__container
    input.search-users(
      type="text"
      autocomplete="new-password"
      v-model="searchWord"
      placeholder="Введите e-mail или имя"
    )
    p.search-users__icon.search-users__icon_search(
      v-if="!searchWord.length"
    )
      include ../assets/svg/search.svg
    p.search-users__icon.search-users__icon_clear(
      v-else
      @click="clearSearchWord"
    )
      include ../assets/svg/clear.svg
    found-users-list(
      v-if="isShowFoundUsersList"
      :foundUsers="application.foundUsers"
      :appName="appName"
      :clearSearchWord="clearSearchWord"
    )
</template>

<script>
import {
  FIND_USERS,
} from '../constants';

import FoundUsersList from './FoundUsersList.vue';

export default {
  name: 'SearchUsersContainer',

  components: {
    FoundUsersList,
  },

  props: {
    appName: {
      type: String,
      required: true,
    },

    application: {
      type: Object,
      required: true,
    },
  },

  data() {
    return {
      searchWord: '',
      foundUsers: null,
    };
  },

  computed: {
    isShowFoundUsersList() {
      return this.application.foundUsers.length && this.searchWord.length;
    },
  },

  watch: {
    searchWord(value) {
      if (value.length) this.searchUsers(value);
    },
  },

  methods: {
    searchUsers(searchWord) {
      this.$store.dispatch(FIND_USERS, { input: searchWord, appName: this.appName });
    },

    clearSearchWord() {
      this.searchWord = '';
    },
  },
};
</script>

<style lang="scss" scoped>
  .search-users__container {
    margin-top: 25px;
    position: relative;

    @include mobile {
      margin-top: 15px;
    }
  }

  .search-users {
    width: 100%;
    height: 48px;
    padding: 0 48px 0 24px;
    outline: none;
    border: solid 1px #cccccc;

    font-size: 16px;
    font-weight: normal;
    font-style: normal;
    font-stretch: normal;
    line-height: 1.31;
    letter-spacing: normal;
    color: #000000;


    /* disable default style in ios */
    -webkit-appearance: none;
    -moz-appearance: none;
    appearance: none;

    /* скрытие плейсхолдера при фокусе */
    &:focus::-webkit-input-placeholder {
      color: transparent;
    }
    &:focus:-moz-placeholder {
      color: transparent;
    } /* FF 4-18 */
    &:focus::-moz-placeholder {
      color:transparent;
    } /* FF 19+ */
    &:focus:-ms-input-placeholder {
      color:transparent;
    } /* IE 10+ */

    @include mobile {
      font-size: 14px;
      line-height: 1.29;
    }

    &::placeholder {
      font-size: 16px;
      font-weight: normal;
      font-style: normal;
      font-stretch: normal;
      line-height: 1.31;
      letter-spacing: normal;
      color: #000000;

      @include mobile {
        font-size: 14px;
        line-height: 1.29;
      }
    }

    @include mobile {
      padding-left: 16px;
      padding-right: 40px;
      &::placeholder {
        white-space: normal;
        font-size: 14px;
        line-height: 1.29;
      }
    }
  }

  .search-users__icon {
    position: absolute;

    &_search {
      top: 16px;
      right: 15px;
    }

    &_clear {
      cursor: pointer;
      top: 12px;
      right: 14px;

      .icon-clear__path {
        fill: #9E9E9E;
      }

      @include hover {
        .icon-clear__path {
          fill: black;
        }
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/SearchUsersContainer.vue